import { Injectable } from '@angular/core';

import { ICccSearchParameters } from '../../models/CccSearchParameters';
import { ExportDetailsModel } from '../../models/ExportDetailsModel';
import { UpdateResult } from '../../models/UpdateResults';
import { ISearchParameters } from '../../pages/page-components/Parameters/search-parameters/searchParameters';
import { BaseApiService } from '../base-api.service';
import { UserService } from '../user/user.service';

@Injectable({
  providedIn: 'root',
})
export class ExportFileService {
  baseUrl = window.location.origin;
  token = '';
  emailAddress = '';

  constructor(
    private baseAPIService: BaseApiService,
    public user: UserService,
  ) {
    this.user.token.subscribe(value => {
      this.token = value;
    });
    this.user.emailAddress.subscribe(value => {
      this.emailAddress = value;
    });
  }

  getExportDetails(exportType: string): Promise<ExportDetailsModel[]> {
    let url =
      this.baseUrl + '/api/export/GetExportDetails?exportType=' + exportType;
    this.baseAPIService.headerToken = this.token;
    this.baseAPIService.userToken = this.emailAddress;
    return this.baseAPIService.get<ExportDetailsModel[]>(url);
  }

  exportSearchResults(
    searchParameters: ISearchParameters,
  ): Promise<UpdateResult> {
    let url = this.baseUrl + '/api/export/PostSearchResults';
    this.baseAPIService.headerToken = this.token;
    this.baseAPIService.userToken = this.emailAddress;
    return this.baseAPIService.postTU<ISearchParameters, UpdateResult>(
      url,
      searchParameters,
    );
  }

  exportCccReportResults(
    searchParameters: ICccSearchParameters,
  ): Promise<UpdateResult> {
    let url = this.baseUrl + '/api/export/PostCccReportResults';
    this.baseAPIService.headerToken = this.token;
    this.baseAPIService.userToken = this.emailAddress;
    return this.baseAPIService.postTU<ICccSearchParameters, UpdateResult>(
      url,
      searchParameters,
    );
  }
}
